// extracted by mini-css-extract-plugin
export default {"title":"styles_title__FMQ7u","doughnut":"styles_doughnut__Ng2Mo","total":"styles_total__2dCTY","chart":"styles_chart__p1g7a","containerChart":"styles_containerChart__dKxDv"};